'use client';

import { c as _c } from "react/compiler-runtime";
import { overlay } from 'overlay-kit';
import { type ReactNode, useEffect } from 'react';
import BottomSheet from '@/app/cc/_component/ui/common/BottomSheet/BottomSheet';
import PrivacyProvideSheet from '@/app/cc/_component/ui/common/BottomSheet/PrivacySheet/PrivacyProvideSheet';
import PrivacyUseSheet from '@/app/cc/_component/ui/common/BottomSheet/PrivacySheet/PrivacyUseSheet';
import styles from '@/app/cc/_component/ui/modal/ConsultationModal/ConsultationModal.module.scss';
interface UseConsultationPrivacySheetParams {
  onAgreePrivacyUse: () => void;
  onAgreePrivacyProvide: () => void;
}
export function useConsultationPrivacySheet(t0) {
  const $ = _c(8);
  const {
    onAgreePrivacyUse,
    onAgreePrivacyProvide
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp2, t1);
  const openPrivacySheet = _temp3;
  let t2;
  if ($[1] !== onAgreePrivacyUse) {
    t2 = () => {
      openPrivacySheet("\uAC1C\uC778\uC815\uBCF4 \uC218\uC9D1 \uBC0F \uC774\uC6A9 \uB3D9\uC758\uC11C", <PrivacyUseSheet />, onAgreePrivacyUse);
    };
    $[1] = onAgreePrivacyUse;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openPrivacyUseSheet = t2;
  let t3;
  if ($[3] !== onAgreePrivacyProvide) {
    t3 = () => {
      openPrivacySheet("\uAC1C\uC778\uC815\uBCF4 \uC81C3\uC790 \uC81C\uACF5 \uB3D9\uC758\uC11C", <PrivacyProvideSheet />, onAgreePrivacyProvide);
    };
    $[3] = onAgreePrivacyProvide;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const openPrivacyProvideSheet = t3;
  let t4;
  if ($[5] !== openPrivacyProvideSheet || $[6] !== openPrivacyUseSheet) {
    t4 = {
      openPrivacyUseSheet,
      openPrivacyProvideSheet
    };
    $[5] = openPrivacyProvideSheet;
    $[6] = openPrivacyUseSheet;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp3(title, content, onAgree) {
  overlay.open(t0 => {
    const {
      isOpen,
      close
    } = t0;
    return <BottomSheet isOpen={isOpen} onClose={close} disableScrollLocking={true} header={<BottomSheet.Header onClose={close}>{title}</BottomSheet.Header>} cta={<BottomSheet.CTA direction="row" layout="full"><button className={styles.cancelButton} type="button" onClick={() => {
        close();
      }}>취소</button><button className={styles.agreeButton} type="button" onClick={() => {
        onAgree();
        close();
      }}>동의</button></BottomSheet.CTA>}>{content}</BottomSheet>;
  });
}
function _temp2() {
  return _temp;
}
function _temp() {
  overlay.closeAll();
}